import styled from 'styled-components';

export const Container = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing(6)};
`;
